// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BRwW","select":"styles_select__3mRf6"};